import React, { useEffect, useState, useMemo } from "react";
import { BiLoaderAlt } from "react-icons/bi";

function LoadingBanner({ loadingArrays = [] }) {
  const [isVisible, setIsVisible] = useState(false);

  const hasLoading = useMemo(() => loadingArrays.some((item) => item.loading === true), [loadingArrays]);

  useEffect(() => {
    setIsVisible(hasLoading);
  }, [hasLoading]);

  return (
    <div className={`absolute right-0 top-[-10px] border border-solid border-gray-200 rounded pl-3 min-w-[200px] text-gray-400 italic text-[12px] bg-white shadow-md cursor-default transition-opacity duration-500 ease-in-out ${isVisible ? "opacity-100" : "opacity-0"}`}>
      {loadingArrays.map((item, index) => item.loading && (
            <div key={index} className="flex items-center">
                {item.message || ""}
                <BiLoaderAlt className="animate-spin" />
            </div>
        )
      )}
    </div>
  );
}

export default React.memo(LoadingBanner);